import { render, staticRenderFns } from "./LockedPaymentInfoModal.vue?vue&type=template&id=1cf058a6&scoped=true"
import script from "./LockedPaymentInfoModal.vue?vue&type=script&lang=ts"
export * from "./LockedPaymentInfoModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf058a6",
  null
  
)

export default component.exports